import { Button, Image, Layout } from "antd";

import { PieChart } from "lucide-react";
import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/store";
import "./Layout.css";
import Sidebar from "./Sidebar";
const { Header, Content, Sider } = Layout;

const Layouts = ({ children }) => {
  const logout = useAuth((state) => state.logout);
  const user = useAuth((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user?.email) {
      navigate("/login");
    }
  }, [user, navigate, location]);

  return (
    <Layout
      style={{
        minHeight: "100vh",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Header className="border-b h-auto px-10 py-3 bg-white shadow-sm">
        <div className="flex px-6 justify-between items-center">
          <Image
            src={"/logo.png"}
            height={50}
            style={{
              borderRadius: 8,
            }}
            preview={false}
          />
          <div className="flex items-center gap-2">
            <Link target="_blank" to="/">
              <Button type="primary" className="flex items-center gap-2">
                <PieChart className="w-4 h-4" />
                Analytics
              </Button>
            </Link>
            <Button type="primary" onClick={() => logout()}>
              Logout
            </Button>
          </div>
        </div>
      </Header>

      <Layout>
        <Sider
          width={288}
          style={{
            background: "#fff",
            height: "calc(100vh - 60px)",
            position: "fixed",
            left: 0,
            overflowX: "hidden",
          }}
          className="custom-sidebar-scroll"
        >
          <Sidebar />
        </Sider>
        <Layout style={{ marginLeft: 288 }}>
          <Content
            style={{
              margin: 0,
              padding: "20px",
              minHeight: 280,
              height: "calc(100vh - 73px)",
              overflow: "auto",
            }}
            className="custom-sidebar-scroll"
          >
            <div>{children}</div>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};
export default Layouts;
